/** DDI do Brasil. O cadastro guarda o telefone como o cliente o escreve — DDD e
 *  número, sem país —, mas o `wa.me` só abre a conversa certa com o número
 *  internacional completo. Sem o prefixo, o link cai numa tela de "número
 *  inválido" e o lojista conclui que o cliente digitou errado. */
const DDI_BRASIL = '55';

/**
 * O link que abre a conversa com este número no WhatsApp.
 *
 * Devolve `null` quando não há telefone utilizável — pedido de balcão costuma
 * não ter nenhum, e quem chama usa isso para não desenhar um botão que levaria a
 * lugar nenhum.
 *
 * `wa.me` em vez do esquema `whatsapp://`: ele funciona no navegador do
 * computador (onde o painel roda o dia inteiro) abrindo o WhatsApp Web, e no
 * celular ele redireciona para o aplicativo sozinho.
 */
export function whatsappLink(phone, text) {
  const digitos = (phone || '').replace(/\D/g, '');
  // Dez dígitos é o mínimo que um número brasileiro tem com DDD (fixo antigo);
  // abaixo disso o campo tem lixo, não telefone.
  if (digitos.length < 10) return null;

  // Já veio com o país (12 ou 13 dígitos começando em 55), respeita; senão
  // prefixa. Prefixar sempre produziria "5555..." em quem já tinha o DDI.
  const completo = digitos.length >= 12 && digitos.startsWith(DDI_BRASIL)
    ? digitos
    : `${DDI_BRASIL}${digitos}`;

  const url = `https://wa.me/${completo}`;
  return text ? `${url}?text=${encodeURIComponent(text)}` : url;
}

/** Abre a conversa numa aba nova.
 *
 *  `noopener` porque a página aberta ganharia acesso a `window.opener` e poderia
 *  navegar o painel para outro lugar — é a precaução padrão para qualquer
 *  `target="_blank"` que aponte para fora. */
export function abrirWhatsapp(phone, text) {
  const url = whatsappLink(phone, text);
  if (!url) return false;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}
